<template>
  <div class="flex items-center cursor-pointer">
    <img 
      :src="prefix[prefixStyle]" 
      alt="prefix" 
      :class="[
      'prefix', 
      { 'not-allowed-prefix': testNode.value[isNotAllowedSelectProp] }
      ]"
    >
    <p class="ml-3">{{ testName }}</p>
  </div>
</template>

<script>
import { getAllDescendants } from '@/utils/va-order-test/testAndPanelSelection/testSelection';
import { getTestCardPrefix } from '../../testCard';
export default {
  props: {
    testNode: {
      type: Object,
      default: () => {}
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect"
    },   
  },
  data() {
    return {
      prefix: {
        unCheck: require("@/assets/orderTest/checkbox_unchecked_filled_white.svg"),
        partCheck: require("@/assets/orderTest/checkbox_indeterminate_box.svg"),
        allCheck: require("@/assets/orderTest/checkbox_checked_filled_white.svg")
      } 
    }
  },
  computed: {
    prefixStyle() {
      let descendants = [];
      getAllDescendants(this.testNode, descendants);
      return getTestCardPrefix(this.testNode, descendants, this.selectProp);
    },
    testName() {
      if (!this.testNode || !this.testNode.value) {
        return "";
      }
      return this.testNode.value.name 
        ? this.testNode.value.name 
        : this.testNode.value.testName;
    }
  }
}
</script>

<style scoped>
.not-allowed-prefix {
  opacity: 0.4;
}

.prefix {
  width: 16px;
  height: 16px;
}
</style>